import cn from 'classnames'
import { bool, string, number, func, instanceOf, arrayOf } from 'prop-types'
import { useRef, useEffect, useState } from 'react'
import CarouselFeedPost from './carousel-feed-post.js'
import preloadPostMedia from '../../../../utilities/preloadPostMedia.js'
import Settings from '../../../../../models/settings.js'
import Post from '../../../../../models/Post.js'
import Locale from '../../../../../models/Locale.js'

const CarouselPost = ({
  post,
  index,
  openGate,
  locale,
  filteredPosts,
  padding,
  openPost,
  maxWidth,
  settings,
  feedKey,
  slideTo,
  hasLeftCarousel,
  leaveCarousel,
  observer,
  slickAutoplay,
  postWidth,
  toggleAutoPlay,
  toggleHasLeftCarousel,
  setCurrentSlide,
}) => {
  const containerRef = useRef()
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (containerRef.current) {
      const parentDom = containerRef.current.parentElement
      const grandParentDom = parentDom.parentElement

      if (grandParentDom.className.includes('slick-current')) {
        setCurrentSlide(grandParentDom)
        setIsActive(true)
      } else {
        setIsActive(false)
      }
    }
  }, [settings, setCurrentSlide])

  return (
    <div
      key={`post-${post.key}`}
      ref={containerRef}
      className={cn('bzfy-c-carousel-slide-wrap', 'bzfy-c-carousel-slide-wrap--clickable')}
      id={`post-${index}`}
      onMouseEnter={() => preloadPostMedia(post)}
    >
      <div style={{ paddingLeft: padding, paddingRight: padding }}>
        <CarouselFeedPost
          feedKey={feedKey}
          goToPost={slideTo}
          hasLeftCarousel={hasLeftCarousel}
          isActive={isActive}
          leaveCarousel={leaveCarousel}
          locale={locale}
          maxPosts={filteredPosts.length}
          observer={observer}
          openPost={() => openPost(post, openGate)}
          post={post}
          postIndex={index}
          postWidth={maxWidth / filteredPosts.length + postWidth}
          settings={settings}
          slickAutoplay={slickAutoplay}
          toggleAutoPlay={toggleAutoPlay}
          toggleHasLeftCarousel={toggleHasLeftCarousel}
        />
      </div>
    </div>
  )
}

CarouselPost.propTypes = {
  feedKey: string.isRequired,
  filteredPosts: arrayOf(instanceOf(Post)).isRequired,
  hasLeftCarousel: bool,
  index: number.isRequired,
  leaveCarousel: func,
  locale: instanceOf(Locale).isRequired,
  maxWidth: number,
  observer: instanceOf(IntersectionObserver),
  openGate: func.isRequired,
  openPost: func,
  padding: number,
  post: instanceOf(Post).isRequired,
  postWidth: number,
  setCurrentSlide: func,
  settings: instanceOf(Settings).isRequired,
  slickAutoplay: bool,
  slideTo: func.isRequired,
  toggleAutoPlay: func,
  toggleHasLeftCarousel: func,
}

export default CarouselPost
